import { responseHandler } from "common/CommanFunction";
import { onGettingFundingReport } from "helpers/fakebackend_helper";
import { call, put, takeEvery } from "redux-saga/effects";
import { getFundingReportFail, getFundingReportSuccess } from "./actions";
import showToast from "common/Notification";
import { GET_FUNDING_REPORT } from "./actionTypes";

const toastTitle = "Funding Report";

function* onGetFundingReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingFundingReport, data);
    yield call(responseHandler, toastTitle, response, getFundingReportSuccess, getFundingReportFail, onSuccess, onError, false);
  } catch (err) {
    onError();
    yield put(getFundingReportFail(err));
    showToast("error", toastTitle, err);
  }
}
function* FundingReportSaga() {
  yield takeEvery(GET_FUNDING_REPORT, onGetFundingReport);
}

export default FundingReportSaga;
